import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const LoomAuthStateQuery: GraphQLTaggedNode = graphql`
	query LoomAuthStateQuery {
		loomUserStatus
	}
`;
